import {SET_DATES_COUNT,SHOW_MESSAGE,SET_INBOX_COUNT,EMAIL_READ,HIDE_MESSAGE,CONFIRM_ACTION,ACTION_CONFIRMED_OR_CANCELED}  from '../actions/types';

const initialState=
{
    message:"",
    title:"",
    text:"",
    ok:"",
    cancel:"",
    inbox:0,
    calendar:0
};

export default function(state = initialState, action)
{
    switch(action.type)
    {
        case SHOW_MESSAGE:
            return {
                ...state,
                message:action.payload
            };
        case SET_INBOX_COUNT:
            return {
                ...state,
                inbox:action.payload
            };
        case SET_DATES_COUNT:
            return {
                ...state,
                calendar:action.payload
            };
        case EMAIL_READ:
            return {
                    ...state,
                    inbox:Math.max(0,state.inbox-1)
                };
        case HIDE_MESSAGE:
            return {
                ...state,
                message:""
            };
        case CONFIRM_ACTION:
            return {
                ...state,
                title:action.payload.title,
                text:action.payload.text,
                ok:action.payload.ok,
                cancel:action.payload.cancel,
                onConfirm:action.payload.onConfirm,
                onCancel:action.payload.onCancel,
                warning:action.payload.warning
            };
        case ACTION_CONFIRMED_OR_CANCELED:
            return {
                ...state,
                title:"",
                text:"",
                ok:"",
                cancel:"",
                onConfirm:null,
                onCancel:null,
                warning:false
            };
        default:
            return state;
    }
}